<template lang="html">
  <dd class="definition-description">
    <slot />
  </dd>
</template>

<script>
export default {
}
</script>

<style lang="scss">
@import '~beisheim/scss/colors';
@import '~beisheim/scss/scale';

.definition-description {
  padding-bottom: scale(5);

  &:not(:last-child) {
    border-bottom: 2px solid gray(4);
  }
}
</style>
